var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbsolute = function SvgAbsolute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.9864 6.1644c.0908-.54477-.2772-1.06-.822-1.15079-.54474-.0908-1.05997.27722-1.15076.82199l-.36073 2.1644h-1.65291c-.55228 0-1 .44772-1 1 0 .55229.44772 1 1 1h1.31957l-.66666 4h-1.65291c-.55228 0-1 .4477-1 1s.44772 1 1 1h1.31957l-.30593 1.8356c-.09079.5448.27722 1.06.82199 1.1508.54478.0908 1.06-.2772 1.1508-.822l.36073-2.1644h3.97244l-.306 1.8356c-.0908.5448.2773 1.06.822 1.1508.5448.0908 1.06-.2772 1.1508-.822l.3608-2.1644h1.6528c.5523 0 1-.4477 1-1s-.4477-1-1-1h-1.3195l.6667-4h1.6528c.5523 0 1-.44771 1-1 0-.55228-.4477-1-1-1h-1.3195l.3059-1.8356c.0908-.54477-.2772-1.06-.822-1.15079-.5447-.0908-1.06.27722-1.1508.82199l-.3607 2.1644h-3.9724zm-.6392 3.8356-.66671 4h3.97241l.6667-4z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbsolute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/absolute.3c081b05.svg";
export { ForwardRef as ReactComponent };